// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Hl9J","menu_item":"Footer_menu_item__12pkm","icon":"Footer_icon__1h_iW","text":"Footer_text__2IT7a","account":"Footer_account__PXdsG"};